module.exports = __webpack_public_path__ + "img/tips2.aac7c86f.png";